import { useEffect } from 'react';
import { UseReportResult } from '@/reports/index';
import { scrollToElement } from '@/utils/index';

export const useScrollToSectionOnNavigate = (
  hash: string,
  queryResult: UseReportResult,
  customTimeDelay?: number
) => {
  useEffect(() => {
    if (hash && queryResult.isSuccess) {
      setTimeout(
        () => {
          const sectionId = hash.substring(1);
          if (sectionId) {
            scrollToElement(sectionId);
          }
        },
        // the 1ms delay is needed to ensure the scroll happens after the page has rendered
        customTimeDelay || 1
      );
    }
  }, [hash, queryResult]);
};
